<script setup>
import DatePicker from 'JIX/components/DatePicker.vue';

import { computed, watch } from 'vue';

import { useStore } from 'vuex';
import { __, __x } from 'JIX/gettext.js';
import { mapParam } from 'JIX/jobsearch/utils.js';
import { dmyToJix, jixToDmy } from 'JIX/utils/date.js';

const store = useStore();
const emit = defineEmits(['hasError']);

const jobageStartDate = mapParam(store, 'mindate');
const jobageEndDate = mapParam(store, 'maxdate');
const jobageFormattedStartDate = computed({
    get() {
        //Display date in 'dd-mm-yyyy' format
        if (jobageStartDate.value){
            return jixToDmy(jobageStartDate.value + '');
        }
        return "";
    },
    set(newDate) {
        //Store date in 'yyyymmdd' format
        jobageStartDate.value = dmyToJix(newDate);
    }
});
const jobageFormattedEndDate = computed({
    get() {
        if (jobageEndDate.value){
            return jixToDmy(jobageEndDate.value + '');
        }
        return "";
    },
    set(newDate) {
        jobageEndDate.value = dmyToJix(newDate);
    }
});
const jobageStartAfterEndError = computed(() => jobageEndDate.value && jobageEndDate.value < jobageStartDate.value);

watch(jobageStartAfterEndError, (val) => emit('hasError', val));
</script>

<template>
    <div>
        <div class="d-flex gap-3 w-100">
            <div class="w-100">
                <label
                    class="control-label"
                    :class="jobageStartAfterEndError ? 'text-danger' : ''"
                >
                    {{ __('Fra dato') }}
                </label>
                <DatePicker
                    id="jobageStartDate"
                    name="jobageStartDate"
                    v-model="jobageFormattedStartDate"
                    data-format="dd-mm-yyyy"
                    :class="jobageStartAfterEndError ? 'error-border-color' : ''"
                />
            </div>
            <div class="w-100">
                <label
                    class="control-label"
                    :class="jobageStartAfterEndError ? 'text-danger' : ''"
                >
                    {{ __('Til dato') }}
                </label>
                <DatePicker
                    id="jobageEndDate"
                    name="jobageEndDate"
                    v-model="jobageFormattedEndDate"
                    data-format="dd-mm-yyyy"
                    :class="jobageStartAfterEndError ? 'error-border-color' : ''"
                />
            </div>
        </div>
        <small class="form-text text-danger" v-if="jobageStartAfterEndError">
            {{ __('Slutdato kan ikke være før startdato') }}
        </small>
    </div>
</template>
